export const LANGS = [
  { code: "tr", label: "Türkçe", short: "TR", dir: "ltr" },
  { code: "en", label: "English", short: "EN", dir: "ltr" },
  { code: "ar", label: "العربية", short: "AR", dir: "rtl" },
];

export const translations = {
  tr: {
    nav: {
      hero: "Ana Sayfa",
      services: "Hizmetler",
      about: "Hakkımızda",
      process: "Süreç",
      contact: "İletişim",
      cta: "Teklif Al",
    },
    hero: {
      badge: "Kurumsal Yazılım & AI Çözümleri",
      taglineA: "Power in Intelligence,",
      taglineB: "Strength in Innovation.",
      desc: "Mobil uygulamadan yapay zekâ ajanlarına, kurumsal yazılım satışından web deneyimlerine — dijital dönüşümünüzü güç ve zekâyla inşa ediyoruz.",
      ctaServices: "Hizmetleri Keşfet",
      ctaContact: "Teklif Al",
      sideLabel: "Est. 2026",
      sideHeading: "Yeni nesil kurumsal yazılım",
      scrollHint: "Kaydırarak keşfet",
    },
    services: {
      eyebrow: "Hizmetlerimiz · 05",
      titleA: "Dijital",
      titleB: "güç",
      titleC: "inşa ediyoruz.",
      desc: "Beş temel disiplinde derinleşmiş ekibimizle, fikir aşamasından teslimat ve sürekli destek aşamasına kadar her adımda yanınızdayız.",
      items: {
        mobil: {
          title: "Mobil Uygulama Yapma",
          subtitle: "iOS & Android • Çapraz Platform",
          desc: "Kullanıcı deneyimi odaklı, yüksek performanslı mobil uygulamalar. Konsept tasarımdan App Store ve Google Play yayınına kadar uçtan uca geliştirme.",
        },
        program: {
          title: "Bilgisayar Program Satışı",
          subtitle: "Lisans • Kurulum • Destek",
          desc: "Kurumsal yazılım lisansları, özel geliştirilmiş masaüstü çözümleri ve sürekli teknik destek paketleri.",
        },
        web: {
          title: "Web Dizaynı",
          subtitle: "UI/UX • Frontend • CMS",
          desc: "Markanızın dijital yüzü olacak, ölçeklenebilir ve yüksek dönüşümlü web deneyimleri.",
        },
        ai: {
          title: "AI Ajan Oluşturma",
          subtitle: "LLM • RAG • Otomasyon",
          desc: "İş süreçlerinizi otomatikleştiren, şirketinize özel yapay zekâ ajanları ve asistanları.",
        },
        danismanlik: {
          title: "Yazılım Danışmanlığı",
          subtitle: "Mimari • Süreç • Eğitim",
          desc: "Teknoloji stratejisi, yazılım mimarisi ve ekip eğitimi konularında uçtan uca danışmanlık.",
        },
      },
    },
    about: {
      eyebrow: "Hakkımızda · MARCHUK LLC",
      titleA: "Yazılıma",
      titleB: "estetik",
      titleC: "ve",
      titleD: "mühendislik.",
      taglineTag: "Slogan",
      taglineHeroA: "Power in Intelligence,",
      taglineHeroB: "Strength in Innovation.",
      leadA: "MARCHUK LLC, kurumsal müşteriler için",
      leadB: "mobil uygulama, yazılım satışı, web tasarım, AI ajanları",
      leadC: "ve",
      leadD: "yazılım danışmanlığı",
      leadE: "alanlarında uçtan uca dijital çözümler sunan uluslararası bir teknoloji şirketidir.",
      sub: "Mühendislik disiplinini editoryal bir tasarım duyarlılığıyla birleştirerek, kullanıcıların deneyimlemek için geri döndüğü, ekiplerin üzerine inşa etmekten keyif aldığı ürünler üretiyoruz.",
      values: [
        {
          title: "Zekâ",
          body: "Her projeyi veriyle, stratejiyle ve derin teknik uzmanlıkla yaklaşıyoruz. Yazılım bizim için bir araç değil, bir düşünce disiplini.",
        },
        {
          title: "Güç",
          body: "Kurumsal ölçekte dayanıklı, güvenli ve ölçeklenebilir çözümler. Yük altında çalışan, sizin ekibinizle birlikte büyüyen altyapılar.",
        },
        {
          title: "İnovasyon",
          body: "AI ajanlarından holografik arayüzlere — yarının teknolojilerini bugünden prodüksiyona alıyoruz. Deneyim bizim için sadece başlangıç.",
        },
      ],
    },
    stats: {
      eyebrow: "Rakamlarla Biz",
      titleA: "Ölçeklenebilir güç,",
      titleB: "kanıtlanmış",
      titleC: "teslimat.",
      items: [
        { suffix: "+", label: "Tamamlanan Proje" },
        { suffix: "+", label: "Kurumsal Müşteri" },
        { suffix: "/7", label: "Destek ve Bakım" },
        { suffix: " Yıl", label: "Sektör Tecrübesi" },
      ],
    },
    process: {
      eyebrow: "Süreç · 4 Adım",
      titleA: "Fikirden",
      titleB: "üretime.",
      desc: "Şeffaf, disiplinli ve hızlı. Her proje aynı titiz süreçten geçer — ama hiçbir çözüm birbirine benzemez.",
      steps: [
        { title: "Keşif & Analiz", body: "Hedeflerinizi, kullanıcıları ve teknik bağlamı anlamak için atölye çalışmaları. Ölçülebilir başarı kriterleri tanımlarız." },
        { title: "Tasarım & Prototip", body: "Editoryal düzeyde görsel dil, etkileşim akışları ve tıklanabilir prototiplerle hızlı doğrulama." },
        { title: "Geliştirme", body: "Modüler mimari, sürekli entegrasyon ve otomatik testler. Şeffaf ilerleme, düzenli sürümler." },
        { title: "Teslimat & Destek", body: "Lansman, performans izleme, güvenlik güncellemeleri ve 24/7 destek paketleriyle sürdürülebilir büyüme." },
      ],
    },
    contact: {
      eyebrow: "İletişim",
      titleA: "Bir proje mi",
      titleB: "konuşalım?",
      desc: "Kısa bir keşif görüşmesi için formu doldurun ya da doğrudan iletişim kanallarımızı kullanın. 24 saat içinde dönüş yapıyoruz.",
      emailLabel: "E-posta",
      phoneLabel: "Telefon",
      addressLabel: "Adres",
      addressLine1: "Tamani Arts Building, Al Asayel Street",
      addressLine2: "Kat 14, Ofis 1453 · Business Bay, Dubai",
      form: {
        name: "Ad Soyad *",
        namePh: "Adınız Soyadınız",
        email: "E-posta *",
        emailPh: "ornek@sirket.com",
        phone: "Telefon",
        phonePh: "(04) 577 1388",
        subject: "Konu *",
        subjectPh: "Proje konusu",
        message: "Mesaj *",
        messagePh: "Projenizi kısaca anlatın...",
        submit: "Mesajı Gönder",
        sending: "Gönderiliyor...",
        success: "Teşekkürler! Mesajınız bize ulaştı. En kısa sürede dönüş yapacağız.",
        errorRequired: "Lütfen zorunlu alanları doldurun.",
        errorGeneric: "Mesaj gönderilemedi. Lütfen birazdan tekrar deneyin.",
      },
    },
    footer: {
      about: "Power in Intelligence,",
      aboutSub: "Strength in Innovation. Kurumsal yazılım, mobil, web ve AI çözümleri.",
      quickLinks: "Hızlı Linkler",
      services: "Hizmetler",
      contactUs: "Bize Ulaşın",
      phone: "Telefon",
      address: "Adres",
      hours: "Çalışma",
      hoursValue: "Pzt – Cum · 09:00 – 18:00",
      rights: "Tüm hakları saklıdır.",
      privacy: "Gizlilik",
      terms: "Şartlar",
      systemActive: "Sistem Aktif",
      servicesList: ["Mobil Uygulama", "Program Satışı", "Web Dizaynı", "AI Ajan Oluşturma", "Yazılım Danışmanlığı"],
    },
    chat: {
      title: "ARCA · MARCHUK AI",
      online: "Çevrimiçi · Claude Sonnet 4.5",
      reset: "Sıfırla",
      placeholder: "Bir mesaj yazın...",
      intro: "Merhaba, ben **ARCA** 👋 — MARCHUK LLC dijital asistanıyım. Hizmetlerimiz, sürecimiz veya projeniz hakkında her şeyi sorabilirsiniz.",
      suggestions: [
        "Hangi hizmetleri sunuyorsunuz?",
        "Mobil uygulama fiyatı ne kadar?",
        "AI ajan nasıl çalışır?",
        "İletişim bilgileri neler?",
      ],
      thinking: "ARCA düşünüyor...",
      footer: "AI tarafından üretilir",
      error: "Üzgünüm, şu anda bağlantı kurulamadı. Lütfen birazdan tekrar deneyin ya da lionsoftware@mmaarchuuk.com adresinden bize ulaşın.",
      openAria: "AI asistanı aç",
      closeAria: "Sohbeti kapat",
    },
  },

  en: {
    nav: {
      hero: "Home",
      services: "Services",
      about: "About",
      process: "Process",
      contact: "Contact",
      cta: "Get a Quote",
    },
    hero: {
      badge: "Corporate Software & AI Solutions",
      taglineA: "Power in Intelligence,",
      taglineB: "Strength in Innovation.",
      desc: "From mobile apps to AI agents, from enterprise software to premium web experiences — we build your digital transformation with power and intelligence.",
      ctaServices: "Explore Services",
      ctaContact: "Get a Quote",
      sideLabel: "Est. 2026",
      sideHeading: "Next-generation corporate software",
      scrollHint: "Scroll to explore",
    },
    services: {
      eyebrow: "Our Services · 05",
      titleA: "Building",
      titleB: "digital",
      titleC: "strength.",
      desc: "With a team specialized in five core disciplines, we stand beside you from the first idea to delivery and continuous support.",
      items: {
        mobil: {
          title: "Mobile App Development",
          subtitle: "iOS & Android • Cross-Platform",
          desc: "User-centered, high-performance mobile apps. End-to-end development from concept to App Store and Google Play release.",
        },
        program: {
          title: "Computer Software Sales",
          subtitle: "Licensing • Setup • Support",
          desc: "Enterprise software licenses, custom-built desktop solutions, and ongoing technical support packages.",
        },
        web: {
          title: "Web Design",
          subtitle: "UI/UX • Frontend • CMS",
          desc: "Scalable, high-conversion web experiences that become the digital face of your brand.",
        },
        ai: {
          title: "AI Agent Creation",
          subtitle: "LLM • RAG • Automation",
          desc: "Tailor-made AI agents and assistants that automate your business processes.",
        },
        danismanlik: {
          title: "Software Consulting",
          subtitle: "Architecture • Process • Training",
          desc: "End-to-end consulting on technology strategy, software architecture, and team enablement.",
        },
      },
    },
    about: {
      eyebrow: "About · MARCHUK LLC",
      titleA: "Software with",
      titleB: "aesthetics",
      titleC: "and",
      titleD: "engineering.",
      taglineTag: "Tagline",
      taglineHeroA: "Power in Intelligence,",
      taglineHeroB: "Strength in Innovation.",
      leadA: "MARCHUK LLC is an international technology company delivering end-to-end digital solutions in",
      leadB: "mobile apps, software sales, web design, AI agents,",
      leadC: "and",
      leadD: "software consulting",
      leadE: "for enterprise clients.",
      sub: "By combining engineering discipline with editorial design sensibility, we build products that users return to experience and teams love to build on.",
      values: [
        {
          title: "Intelligence",
          body: "We approach every project with data, strategy, and deep technical expertise. Software is not a tool for us — it is a discipline of thought.",
        },
        {
          title: "Strength",
          body: "Resilient, secure, and scalable solutions at enterprise scale. Infrastructure that runs under load and grows with your team.",
        },
        {
          title: "Innovation",
          body: "From AI agents to holographic interfaces — we ship tomorrow's technologies into production today. Experience is only the beginning.",
        },
      ],
    },
    stats: {
      eyebrow: "By the Numbers",
      titleA: "Scalable strength,",
      titleB: "proven",
      titleC: "delivery.",
      items: [
        { suffix: "+", label: "Completed Projects" },
        { suffix: "+", label: "Enterprise Clients" },
        { suffix: "/7", label: "Support & Maintenance" },
        { suffix: " Yrs", label: "Industry Experience" },
      ],
    },
    process: {
      eyebrow: "Process · 4 Steps",
      titleA: "From idea",
      titleB: "to production.",
      desc: "Transparent, disciplined, and fast. Every project goes through the same rigorous process — yet no two solutions are alike.",
      steps: [
        { title: "Discovery & Analysis", body: "Workshops to understand your goals, users, and technical context. We define measurable success criteria." },
        { title: "Design & Prototype", body: "Editorial-grade visual language, interaction flows, and clickable prototypes for rapid validation." },
        { title: "Development", body: "Modular architecture, continuous integration, and automated tests. Transparent progress, regular releases." },
        { title: "Launch & Support", body: "Launch, performance monitoring, security updates, and 24/7 support packages for sustainable growth." },
      ],
    },
    contact: {
      eyebrow: "Contact",
      titleA: "Shall we",
      titleB: "talk?",
      desc: "Fill in the form for a short discovery call or reach out directly through our channels. We respond within 24 hours.",
      emailLabel: "Email",
      phoneLabel: "Phone",
      addressLabel: "Address",
      addressLine1: "Tamani Arts Building, Al Asayel Street",
      addressLine2: "Floor 14, Office 1453 · Business Bay, Dubai",
      form: {
        name: "Full Name *",
        namePh: "Your full name",
        email: "Email *",
        emailPh: "you@company.com",
        phone: "Phone",
        phonePh: "(04) 577 1388",
        subject: "Subject *",
        subjectPh: "Project subject",
        message: "Message *",
        messagePh: "Tell us briefly about your project...",
        submit: "Send Message",
        sending: "Sending...",
        success: "Thank you! Your message has reached us. We will get back to you shortly.",
        errorRequired: "Please fill in the required fields.",
        errorGeneric: "Message could not be sent. Please try again shortly.",
      },
    },
    footer: {
      about: "Power in Intelligence,",
      aboutSub: "Strength in Innovation. Enterprise software, mobile, web, and AI solutions.",
      quickLinks: "Quick Links",
      services: "Services",
      contactUs: "Contact Us",
      phone: "Phone",
      address: "Address",
      hours: "Hours",
      hoursValue: "Mon – Fri · 09:00 – 18:00",
      rights: "All rights reserved.",
      privacy: "Privacy",
      terms: "Terms",
      systemActive: "System Active",
      servicesList: ["Mobile App", "Software Sales", "Web Design", "AI Agent Creation", "Software Consulting"],
    },
    chat: {
      title: "ARCA · MARCHUK AI",
      online: "Online · Claude Sonnet 4.5",
      reset: "Reset",
      placeholder: "Type a message...",
      intro: "Hi, I'm **ARCA** 👋 — the MARCHUK LLC digital assistant. Ask me anything about our services, process, or your project.",
      suggestions: [
        "What services do you offer?",
        "How much does a mobile app cost?",
        "How does an AI agent work?",
        "What are your contact details?",
      ],
      thinking: "ARCA is thinking...",
      footer: "AI-generated",
      error: "Sorry, I couldn't reach the server. Please try again shortly or email us at lionsoftware@mmaarchuuk.com.",
      openAria: "Open AI assistant",
      closeAria: "Close chat",
    },
  },

  ar: {
    nav: {
      hero: "الرئيسية",
      services: "الخدمات",
      about: "من نحن",
      process: "العملية",
      contact: "تواصل",
      cta: "اطلب عرضًا",
    },
    hero: {
      badge: "حلول البرمجيات المؤسسية والذكاء الاصطناعي",
      taglineA: "Power in Intelligence,",
      taglineB: "Strength in Innovation.",
      desc: "من تطبيقات الجوال إلى وكلاء الذكاء الاصطناعي، ومن البرمجيات المؤسسية إلى تجارب الويب المميزة — نبني تحولكم الرقمي بالقوة والذكاء.",
      ctaServices: "استكشف الخدمات",
      ctaContact: "اطلب عرضًا",
      sideLabel: "تأسست 2026",
      sideHeading: "برمجيات مؤسسية من الجيل الجديد",
      scrollHint: "مرر للاستكشاف",
    },
    services: {
      eyebrow: "خدماتنا · 05",
      titleA: "نبني",
      titleB: "القوة",
      titleC: "الرقمية.",
      desc: "بفريق متخصص في خمسة تخصصات جوهرية، نقف بجانبكم من الفكرة الأولى حتى التسليم والدعم المستمر.",
      items: {
        mobil: {
          title: "تطوير تطبيقات الجوال",
          subtitle: "iOS وAndroid • متعدد المنصات",
          desc: "تطبيقات جوال عالية الأداء تركّز على تجربة المستخدم. تطوير شامل من المفهوم حتى النشر على App Store وGoogle Play.",
        },
        program: {
          title: "بيع برامج الكمبيوتر",
          subtitle: "تراخيص • تركيب • دعم",
          desc: "تراخيص برمجيات مؤسسية، حلول سطح مكتب مخصصة، وباقات دعم فني متواصلة.",
        },
        web: {
          title: "تصميم الويب",
          subtitle: "UI/UX • واجهة أمامية • CMS",
          desc: "تجارب ويب قابلة للتوسع وعالية التحويل تكون الوجه الرقمي لعلامتكم.",
        },
        ai: {
          title: "إنشاء وكلاء ذكاء اصطناعي",
          subtitle: "LLM • RAG • أتمتة",
          desc: "وكلاء ومساعدون ذكاء اصطناعي مخصصون لأتمتة عملياتكم التجارية.",
        },
        danismanlik: {
          title: "استشارات البرمجيات",
          subtitle: "معمارية • عملية • تدريب",
          desc: "استشارات شاملة في استراتيجية التكنولوجيا ومعمارية البرمجيات وتمكين الفرق.",
        },
      },
    },
    about: {
      eyebrow: "من نحن · MARCHUK LLC",
      titleA: "برمجيات تجمع",
      titleB: "الجمال",
      titleC: "و",
      titleD: "الهندسة.",
      taglineTag: "الشعار",
      taglineHeroA: "Power in Intelligence,",
      taglineHeroB: "Strength in Innovation.",
      leadA: "MARCHUK LLC شركة تكنولوجيا دولية تقدم حلولًا رقمية متكاملة في",
      leadB: "تطبيقات الجوال، بيع البرمجيات، تصميم الويب، وكلاء الذكاء الاصطناعي،",
      leadC: "و",
      leadD: "استشارات البرمجيات",
      leadE: "للعملاء المؤسسيين.",
      sub: "من خلال دمج الانضباط الهندسي مع حس التصميم التحريري، نصنع منتجات يعود المستخدمون لتجربتها وتستمتع الفرق بالبناء عليها.",
      values: [
        {
          title: "الذكاء",
          body: "نتعامل مع كل مشروع بالبيانات والاستراتيجية والخبرة الفنية العميقة. البرمجيات ليست أداة بالنسبة لنا — بل منهج تفكير.",
        },
        {
          title: "القوة",
          body: "حلول مرنة وآمنة وقابلة للتوسع على نطاق مؤسسي. بنية تحتية تعمل تحت الضغط وتنمو مع فريقكم.",
        },
        {
          title: "الابتكار",
          body: "من وكلاء الذكاء الاصطناعي إلى الواجهات الهولوغرافية — ننقل تقنيات الغد إلى الإنتاج اليوم. التجربة مجرد البداية.",
        },
      ],
    },
    stats: {
      eyebrow: "بالأرقام",
      titleA: "قوة قابلة للتوسع،",
      titleB: "تسليم",
      titleC: "موثّق.",
      items: [
        { suffix: "+", label: "مشروع مُنجز" },
        { suffix: "+", label: "عميل مؤسسي" },
        { suffix: "/7", label: "دعم وصيانة" },
        { suffix: " سنة", label: "خبرة في القطاع" },
      ],
    },
    process: {
      eyebrow: "العملية · 4 خطوات",
      titleA: "من الفكرة",
      titleB: "إلى الإنتاج.",
      desc: "شفاف، منضبط، سريع. كل مشروع يمر بالعملية الدقيقة ذاتها — لكن لا يوجد حلان متشابهان.",
      steps: [
        { title: "الاكتشاف والتحليل", body: "ورش عمل لفهم أهدافكم والمستخدمين والسياق التقني. نحدد معايير نجاح قابلة للقياس." },
        { title: "التصميم والنموذج", body: "لغة بصرية بمستوى تحريري، تدفقات تفاعل، ونماذج قابلة للنقر للتحقق السريع." },
        { title: "التطوير", body: "معمارية معيارية، تكامل مستمر، واختبارات تلقائية. تقدم شفاف، إصدارات منتظمة." },
        { title: "الإطلاق والدعم", body: "الإطلاق، مراقبة الأداء، تحديثات الأمان، وباقات دعم على مدار 24/7 لنمو مستدام." },
      ],
    },
    contact: {
      eyebrow: "تواصل",
      titleA: "هل نتحدث",
      titleB: "عن مشروعكم؟",
      desc: "املؤوا النموذج لجلسة اكتشاف قصيرة أو تواصلوا مباشرة عبر قنواتنا. نعود إليكم خلال 24 ساعة.",
      emailLabel: "البريد الإلكتروني",
      phoneLabel: "الهاتف",
      addressLabel: "العنوان",
      addressLine1: "مبنى Tamani Arts، شارع العسيل",
      addressLine2: "الطابق 14، مكتب رقم 1453 · الخليج التجاري، دبي",
      form: {
        name: "الاسم الكامل *",
        namePh: "اسمكم الكامل",
        email: "البريد الإلكتروني *",
        emailPh: "you@company.com",
        phone: "الهاتف",
        phonePh: "(04) 577 1388",
        subject: "الموضوع *",
        subjectPh: "موضوع المشروع",
        message: "الرسالة *",
        messagePh: "أخبرونا باختصار عن مشروعكم...",
        submit: "إرسال الرسالة",
        sending: "جارٍ الإرسال...",
        success: "شكرًا لكم! وصلتنا رسالتكم وسنعود إليكم قريبًا.",
        errorRequired: "يرجى تعبئة الحقول المطلوبة.",
        errorGeneric: "تعذّر إرسال الرسالة. يرجى المحاولة لاحقًا.",
      },
    },
    footer: {
      about: "Power in Intelligence,",
      aboutSub: "Strength in Innovation. حلول برمجيات مؤسسية وجوال وويب وذكاء اصطناعي.",
      quickLinks: "روابط سريعة",
      services: "الخدمات",
      contactUs: "تواصل معنا",
      phone: "الهاتف",
      address: "العنوان",
      hours: "ساعات العمل",
      hoursValue: "الإثنين – الجمعة · 09:00 – 18:00",
      rights: "جميع الحقوق محفوظة.",
      privacy: "الخصوصية",
      terms: "الشروط",
      systemActive: "النظام نشط",
      servicesList: ["تطبيقات الجوال", "بيع البرمجيات", "تصميم الويب", "وكلاء الذكاء الاصطناعي", "استشارات البرمجيات"],
    },
    chat: {
      title: "ARCA · MARCHUK AI",
      online: "متصل · Claude Sonnet 4.5",
      reset: "إعادة",
      placeholder: "اكتبوا رسالة...",
      intro: "مرحبًا، أنا **ARCA** 👋 — المساعد الرقمي لـ MARCHUK LLC. اسألوني أي شيء عن خدماتنا أو عمليتنا أو مشروعكم.",
      suggestions: [
        "ما الخدمات التي تقدمونها؟",
        "كم تكلفة تطبيق الجوال؟",
        "كيف يعمل وكيل الذكاء الاصطناعي؟",
        "ما هي معلومات التواصل؟",
      ],
      thinking: "ARCA يفكّر...",
      footer: "تم الإنشاء بالذكاء الاصطناعي",
      error: "عذرًا، تعذّر الاتصال حاليًا. يرجى المحاولة لاحقًا أو مراسلتنا على lionsoftware@mmaarchuuk.com.",
      openAria: "فتح المساعد الذكي",
      closeAria: "إغلاق المحادثة",
    },
  },
};
